import type React from 'react';
import { clsx } from 'clsx';

import classes from './LineLoader.module.scss';
import type { LineLoaderProps } from './types';
import { useLineLoaderView } from './useLineLoaderView';

export const LineLoader: React.FC<LineLoaderProps> = (props) => {
  const { height = '4px', placement = 'top' } = props;

  const { rootProps, ribbonProps } = useLineLoaderView(props, classes);

  return (
    <div className={clsx(rootProps.className, classes[placement])} style={{ height }}>
      <div className={ribbonProps.className}></div>
    </div>
  );
};
